import * as React from 'react';
import { useFilterList } from '../../utils';
import { FilterInput } from './FilterInput';
import { FilterProps } from './FilterProps';
export function FilterList(props) {
    var _a, _b;
    var _c = useFilterList(props.items, props.filterKey, '', (_a = props.filterDelay) !== null && _a !== void 0 ? _a : 300), rawData = _c.rawData, applyFilter = _c.applyFilter, resetFilter = _c.resetFilter, filteredItems = _c.filteredItems;
    return (React.createElement(React.Fragment, null,
        React.createElement(FilterInput, { isTransparent: props.isTransparent, placeholder: (_b = props.placeholder) !== null && _b !== void 0 ? _b : '', onChange: function (e) {
                applyFilter(e.currentTarget.value);
            } }),
        React.createElement(FilterProps, { items: rawData, visible: filteredItems, resetFilter: resetFilter }, props.children)));
}
//# sourceMappingURL=FilterList.js.map